import { useState, useEffect } from 'react';

export const useDynamicInputWidth = (inputRef, placeholder) => {
    const [inputWidth, setInputWidth] = useState('auto');

    useEffect(() => {
        if (inputRef.current) {
            const computedStyle = window.getComputedStyle(inputRef.current);
            const span = document.createElement('span');
            span.style.visibility = 'hidden';
            span.style.position = 'absolute';
            span.style.whiteSpace = 'nowrap';
            span.style.fontSize = computedStyle.fontSize;
            span.style.fontFamily = computedStyle.fontFamily;
            span.style.fontWeight = computedStyle.fontWeight;
            span.style.letterSpacing = computedStyle.letterSpacing;
            span.style.textTransform = computedStyle.textTransform;
            span.textContent = placeholder;
            document.body.appendChild(span);
            const textWidth = span.offsetWidth;
            document.body.removeChild(span);
            const paddingLeft = parseFloat(computedStyle.paddingLeft);
            const paddingRight = parseFloat(computedStyle.paddingRight);
            const totalPadding = paddingLeft + paddingRight;
            const marginLeft = parseFloat(computedStyle.marginLeft);
            const marginRight = parseFloat(computedStyle.marginRight);
            const totalMargin = marginLeft + marginRight;
            setInputWidth(textWidth + totalPadding + totalMargin + 5);
        }
    }, [placeholder]);

    return inputWidth;
};
